// import { Popover } from "antd"
import classNames from "classnames"
import { Tooltip } from ".."
import styles from "./index.module.less"

const HoverText = ({ data, message, scrollable }) => {
  const content = (
    <div className={classNames({ [styles.tooltipScroll]: scrollable })}>
      {data.map((item, index) => {
        return (
          <p key={index} className="mbe-8">
            {item}
          </p>
        )
      })}
    </div>
  )

  return (
    <Tooltip title={content} trigger="hover">
      {message}
    </Tooltip>
  )
}

export default HoverText
